import { render, staticRenderFns } from "./library.vue?vue&type=template&id=6520c890&scoped=true"
import script from "./library.vue?vue&type=script&lang=js"
export * from "./library.vue?vue&type=script&lang=js"
import style0 from "./library.vue?vue&type=style&index=0&id=6520c890&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6520c890",
  null
  
)

export default component.exports